import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import Icon from '../Icon';
import Tooltip from '../Tooltip';
import classNames from 'classnames';
import Progress from '../Progress';

var FileShowList = /*#__PURE__*/function (_React$Component) {
  _inherits(FileShowList, _React$Component);

  var _super = _createSuper(FileShowList);

  function FileShowList() {
    var _this;

    _classCallCheck(this, FileShowList);

    _this = _super.apply(this, arguments);

    _this.renderUploadFailFile = function (file) {
      var disabled = _this.props.disabled;
      return /*#__PURE__*/React.createElement("div", {
        className: classNames('roo-upload-list-item', 'roo-upload-list-item-error')
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "file-text",
        className: classNames('roo-upload-list-icon', 'roo-upload-list-icon-error'),
        size: 16
      }), /*#__PURE__*/React.createElement("span", null, file.name), disabled ? null : /*#__PURE__*/React.createElement(Icon, {
        name: "trash-o",
        size: 16,
        onClick: function onClick() {
          _this.props.onFileRemove(file);
        },
        className: classNames('roo-upload-list-trash', 'roo-upload-list-trash-error')
      }));
    };

    _this.renderSuccess = function (file) {
      var disabled = _this.props.disabled;
      return /*#__PURE__*/React.createElement("div", {
        onClick: function onClick(event) {
          _this.props.onPreview(file, event);
        },
        className: classNames('roo-upload-list-item')
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "file-text",
        className: classNames('roo-upload-list-icon'),
        size: 16
      }), /*#__PURE__*/React.createElement("span", null, file.name), disabled ? null : /*#__PURE__*/React.createElement(Icon, {
        name: "trash-o",
        size: 16,
        onClick: function onClick(event) {
          event.stopPropagation();

          _this.props.onFileRemove(file, event);
        },
        className: classNames('roo-upload-list-trash')
      }));
    };

    _this.renderUploadingFile = function (file) {
      var percent = Math.round(file.percent || 10);
      var onFileRemove = _this.props.onFileRemove;
      return /*#__PURE__*/React.createElement("div", {
        className: "roo-upload-list-item roo-upload-list-item-loading"
      }, /*#__PURE__*/React.createElement("div", {
        className: "roo-upload-list-item-name"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "file-text",
        className: classNames('roo-upload-list-icon'),
        size: 16
      }), /*#__PURE__*/React.createElement("span", null, file.name), /*#__PURE__*/React.createElement(Icon, {
        name: "trash-o",
        size: 16,
        onClick: function onClick() {
          onFileRemove(file);
        },
        className: classNames('roo-upload-list-trash')
      })), /*#__PURE__*/React.createElement("div", {
        className: "roo-upload-list-uploading-bar"
      }, /*#__PURE__*/React.createElement(Progress, {
        animation: true,
        animationDuration: 1,
        height: 3,
        percentage: percent
      })));
    };

    _this.renderInit = function (file) {
      var percent = 0;
      var onFileRemove = _this.props.onFileRemove;
      return /*#__PURE__*/React.createElement("div", {
        className: "roo-upload-list-item roo-upload-list-item-loading"
      }, /*#__PURE__*/React.createElement("div", {
        className: "roo-upload-list-item-name"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "file-text",
        className: classNames('roo-upload-list-icon'),
        size: 16
      }), /*#__PURE__*/React.createElement("span", null, file.name), /*#__PURE__*/React.createElement(Icon, {
        name: "trash-o",
        size: 16,
        onClick: function onClick() {
          onFileRemove(file);
        },
        className: classNames('roo-upload-list-trash')
      })), /*#__PURE__*/React.createElement("div", {
        className: "roo-upload-list-uploading-bar"
      }, /*#__PURE__*/React.createElement(Progress, {
        animation: true,
        animationDuration: 1,
        height: 3,
        showText: true,
        percentage: percent
      })));
    };

    _this.renderCardItem = function (file) {
      switch (file.status) {
        case 'fail':
          return _this.renderUploadFailFile(file);

        case 'uploading':
          return _this.renderUploadingFile(file);

        case 'success':
        default:
          return _this.renderSuccess(file);
      }
    };

    _this.renderFileLoad = function () {
      var renderLoader = _this.props.renderLoader;
      var loader = renderLoader();
      if (!loader) return null;
      return /*#__PURE__*/React.createElement("div", {
        className: "roo-upload-list-load"
      }, loader);
    };

    return _this;
  }

  _createClass(FileShowList, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var fileList = this.props.fileList;
      if (!fileList || fileList.length === 0) return this.renderFileLoad();
      return /*#__PURE__*/React.createElement("div", {
        className: "roo-upload-list-container"
      }, this.renderFileLoad(), /*#__PURE__*/React.createElement("div", null, fileList.map(function (file) {
        return /*#__PURE__*/React.createElement(Tooltip, {
          placement: "topLeft",
          key: file.uid,
          content: file.errorInfo
        }, /*#__PURE__*/React.createElement("span", null, _this2.renderCardItem(file)));
      })));
    }
  }]);

  return FileShowList;
}(React.Component);

export default FileShowList;